var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"on-demand_button",attrs:{"id":"TransferOnDemandButton"},on:{"click":() =>
      _vm.handleTransferToOnDemand({
        testCode: _vm.grade.testCd,
        classID: _vm.grade.classId,
      })}},[_c('IconPlayOnDemand')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }